/**
 * Identidad visual de Comandero para las pantallas de auth (kit #13 — des-clon).
 *
 * Tras la des-clonación, las pantallas dejan de usar el panel de marca de 3
 * densidades (`split`/`hero`/`aside`) del kit compartido; el shell propio
 * (`auth-kiosk.tsx`) sólo necesita el **glifo de marca** y la **ilustración
 * ambiental**. Motivo distintivo: una **comanda / ticket de servicio** (no la
 * cloche del logo), `currentColor`/tokens → theme-safe.
 */

/**
 * Glifo de marca para el chip: un **ticket de comanda** con líneas de pedido y
 * borde dentado inferior. Distinto del logo (cloche) a propósito, para dar
 * identidad propia a las pantallas de auth. `currentColor` = theme-safe.
 */
export function ComanderoMark(props: { class?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
      aria-hidden="true"
    >
      {/* Cuerpo del ticket */}
      <path
        d="M8 4h16v20l-2.5-1.7L19 24l-3-1.7L13 24l-2.5-1.7L8 24z"
        fill="currentColor"
        fill-opacity="0.18"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linejoin="round"
      />
      {/* Líneas de pedido */}
      <path
        d="M12 9.5h8M12 13h8M12 16.5h5"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      />
    </svg>
  );
}

/**
 * Ilustración decorativa: una comanda grande con líneas de pedido y un check de
 * "servido". `aria-hidden`, `currentColor` para verse bien en cualquier tema.
 */
export function TicketIllustration(props: { class?: string }) {
  return (
    <div class={`pointer-events-none ${props.class ?? ""}`} aria-hidden="true">
      <svg
        viewBox="0 0 320 320"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="h-full w-auto max-w-none"
      >
        <circle cx="160" cy="160" r="150" stroke="currentColor" stroke-width="2" />
        <circle cx="160" cy="160" r="112" stroke="currentColor" stroke-width="2" />
        {/* Ticket de comanda */}
        <path
          d="M104 70h112v150l-14-10-14 10-14-10-14 10-14-10-14 10-14-10-14 10z"
          fill="currentColor"
          fill-opacity="0.5"
          stroke="currentColor"
          stroke-width="6"
          stroke-linejoin="round"
        />
        {/* Líneas de pedido */}
        <path
          d="M128 104h64M128 130h64M128 156h40"
          stroke="currentColor"
          stroke-width="7"
          stroke-linecap="round"
          stroke-opacity="0.85"
        />
        {/* Check de servido */}
        <path
          d="M132 186l12 12 24-26"
          stroke="currentColor"
          stroke-width="8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}
